module.exports = __webpack_public_path__ + "img/2.a498a199.png";